import "sitecss/site.css";
import "sitecss/inner.css";
//import * as util from "./site";
import * as qtipval from "./jquery.qtip.validation";
//import "toastr";


declare global {
    interface Window {
        unHighlightField?: Function;
    }
}
//function innerInit() {
//    util.messageBoxOk("hello", "hey, here's a message");
//    //Object.assign(window, util);
//    //Object.assign(window, qtipval);
//    //if (window.DoNotInitQtipVal != true) qtipval.qTipValInit();
//}

//innerInit();

//import * as util from "./site";
//util.messageBoxOk("hello", "hey, here's a message");
window.unHighlightField = qtipval.unHighlightField;

qtipval.qTipValInit();

$(document).on("click", ".view-tutorial", function () {
    var win = $("<div class=\"tutorial\"><video autoplay controls><source src=\"" + $(this).data("tutorial-url") + "\" type=\"video/mp4\"></video></div>").kendoWindow({
        modal: true,
        actions: ["Close"],
        title: "Tutorial",
        visible: false,
        resize: function () {
            this.center();
        },
        open: function () {
            setTimeout(() => { this.center(); }, 100);
        },
        deactivate: function () {
            this.destroy();
        }
    });

    win.data("kendoWindow").center().open();
});
